import replace from "lodash/replace";
import chunk from "lodash/chunk";
import join from 'lodash/join'
import head from 'lodash/head'
import slice from 'lodash/slice'

export  function userNumber(strNumber) {
    return replace(strNumber, "972", "0");
}

export  function formatInternationalNumber(strNumber) {
    let countryCodefirst = head(strNumber)
    let otherPart = chunk(strNumber, 4)
    let countryCode = slice(strNumber, 1, 4)
    otherPart = join([join(otherPart[1], ''), join(otherPart[2], '')], '')
    countryCode = join([countryCodefirst, join(countryCode, '')], '-')
    countryCode = join ([countryCode, otherPart], '-')
    return countryCode
}